import whiteLabelConfigQuery from "@/apps/whiteLabelWebsite/whiteLabel/core/application/bridge/query/configQuery";
import { useRoute } from "vue-router";
import { useLayoutConfigStore } from "@/core/store/config/configStore";
import { inject, computed } from "vue";

export const useContainerLayout = () => {
  const isPublicApp = inject<boolean>("isPublicApp");
  const route = useRoute();

  const { getLayoutConfig } = useLayoutConfigStore();

  const isLayoutContainerFluid = computed(() => {
    return getLayoutConfig("content.width") === "fluid";
  });

  const displayBackToClientWebsiteLink = computed(() => {
    if (!isPublicApp) {
      return false;
    }

    const externalWebsiteConfig = whiteLabelConfigQuery.getConfig().externalWebsiteLink;
    if (!externalWebsiteConfig?.active) {
      return false;
    }

    return route.meta?.shouldDisplayClientWebsiteLink === true;
  });

  return {
    isLayoutContainerFluid,
    displayBackToClientWebsiteLink,
  };
};
